// Internal module imports
import { HttpClient } from '../utils/httpClient';

const PATH = {
    create: '/admin/instance',
    read_all: '/admin/instance',
    update: '/admin/instance',
    delete: '/admin/instance',
    read_all_instance_inventory: '/admin/instance/inventory',
    updateForceFactor: '/admin/data/force-factor',
    forceActivation: '/admin/data/force-activation',
    instanceDetails: '/admin/data/intance-details',
    getApprovedCapacity: '/admin/instance/afrr-approved-capacity',
};

const Create = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(PATH.create, payload).then(callback).catch(error).finally(next);
};

const ReadAll = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.read_all}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const Update = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.update}/${id}`, payload).then(callback).catch(error).finally(next);
};

const Delete = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${id}`).then(callback).catch(error).finally(next);
};

const ReadAllInstanceInventory = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.read_all_instance_inventory}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const UpdateForceFactor = (payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.updateForceFactor}`, payload).then(callback).catch(error).finally(next);
};

const ForceActivation = (params, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.forceActivation}`, params).then(callback).catch(error).finally(next);
};

const GetInstanceDetails = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.instanceDetails}/${id}`).then(callback).catch(error).finally(next);
};

const GetInstanceApprovedCapacity = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getApprovedCapacity}`, { params }).then(callback).catch(error).finally(next);
};

export const InstanceService = {
    Create,
    ReadAll,
    Update,
    Delete,
    ReadAllInstanceInventory,
    UpdateForceFactor,
    ForceActivation,
    GetInstanceDetails,
    GetInstanceApprovedCapacity,
};
